import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['popover'];

  connect() {
    this.handlePopoverClick();
  }

  handlePopoverClick() {
    const popoverTrigger = document.querySelector('[data-popover-target="accountant-popover"]');
    const popoverTriggerChild = document.querySelector('[data-popover-target="accountant-popover"] > div');

    popoverTrigger.addEventListener('click', () => {
      if (this.popoverTarget.classList.contains('opacity-0')) popoverTriggerChild.classList.remove('border-gray-100');
      if (this.popoverTarget.classList.contains('opacity-1')) popoverTriggerChild.classList.add('border-gray-100');
    });
  }
}
